import { SortCell, TextCell } from "../cells";
import { Column, RowData } from "../types";

interface RowDataWithRecordDateEnd extends RowData {
  recordDateEnd: string;
}

export const recordDateEndColumn: Column<RowDataWithRecordDateEnd> = {
  label: (
    <SortCell sortKey="record_date_end" emphasis="medium">
      Record End
    </SortCell>
  ),
  width: "1fr",
  cell: (filing) => (
    <TextCell emphasis="medium">{filing.recordDateEnd || "-"}</TextCell>
  ),
};
